import { useScopedTranslation } from 'app/hooks/i18n';
import { safelyOpenURL } from 'app/lib/navigation';
import { Column, Row } from 'app/design/primitives/box';

import { Text } from 'app/design/primitives/text';
import { Trans } from 'react-i18next';
import { Separator } from 'app/design/primitives/text-divider';
import { ArrowTopRight } from 'app/design/icons/arrow-top-right';
import { Pressable } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconInfoCircle } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

export function BaconSection() {
  const { t } = useScopedTranslation();

  return (
    <Pressable onPress={() => void safelyOpenURL(t('baconBanner.link'))}>
      <Row
        gap="spacing.general.x4"
        style={{
          backgroundColor: theme.colors['surface.tertiary-neutral'],
          padding: theme.spacing['spacing.general.x4'],
        }}
      >
        <IconInfoCircle strokeWidth={ICON_STROKE_WIDTH} size={30} color="transparent" />
        <Column flex={1} gap="spacing.general.x4">
          <Text variant="bodyBase">
            <Trans components={{ strong: <Text fontWeight="700" /> }} i18nKey="baconBanner.text" ns="new" />
          </Text>
          <Separator />
          <Row alignItems="center" justifyContent="center">
            <Text
              flex={1}
              style={{ color: theme.colors['text.secondary'], textDecorationLine: 'underline' }}
              variant="bodyBase"
            >
              {t('baconBanner.linkText')}
            </Text>
            <ArrowTopRight />
          </Row>
        </Column>
      </Row>
    </Pressable>
  );
}
